// extracted by mini-css-extract-plugin
module.exports = {"disabled":"FunctionEditorSwitch_disabled__2gUX4","field":"FunctionEditorSwitch_field__229QM"};